module.exports = __webpack_public_path__ + "assets/register-v2-dark.4117841f.svg";